export default __webpack_public_path__ + "static/media/avatar.cc06eacb.svg";